import React, { useEffect, useState, useRef } from "react";
import Header from "../../layout/Header";
import { ValidatorForm } from "react-form-validator-core";
import TextValidator from "../../partial/TextValidator";
import CKEditor from "ckeditor4-react";
import SmsSetting from "./SmsSetting";
import { EMAIL_TEMPLATE_COLUMN } from "./emailTemplateCol";
import SelectValidator from "../../partial/SelectValidator";
import {
  customerPortalSetting,
  deleteEmailTemplateSetting,
  getEmailTemplateSetting,
  schema,
  updateEmailTemplateSetting,
} from "../campaigns/services";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import { getDropdownObject } from "../../../utils/helper";
import EmailTemplateModal from "./EmailTemplateModal";
import { decrypt } from "../../../utils/encodingdecoding";
import { getCustomer } from "../../../actions/schema";
import Paginated from "../membership/Paginated";

function EmailTemplate() {
  const [response, setResponse] = useState();
  const [templateModal, showTemplateModal] = useState({
    isOpen: false,
    body: "",
  });
  const [data, setData] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [schemaData, setSchemaData] = useState();
  const [error, setError] = useState(null);
  const [typeDisplay] = useState([
    { value: "", label: "Select" },
    { value: "Transaction", label: "Transaction" },
    { value: "Redemption", label: "Redemption" },
    { value: "Voucher Purchase", label: "Voucher Purchase" },
    { value: "Giftcard Purchase", label: "GiftCard Purchase" },
  ]);
  const [loader, setLoader] = useState(false);
  const [emailSetting, setEmailSetting] = useState({
    fromEmail: "",
    fromName: "",
    EmailType: "",
    Subject: "",
    Body: "",
    status: false,
    emailPlaceholder: [],
    templateName: "",
    selectedType: "",
  });
  const [selectedPlaceholders, setSelectedPlaceholders] = useState([]);
  const [activeMode, setActiveMode] = useState("custom");
  const [customHTML, setCustomHTML] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  const ckEditorRef = useRef(null);
  const {
    fromEmail,
    fromName,
    EmailType,
    selectedType,
    Subject,
    Body,
    status,
    templateName,
  } = emailSetting;

  const handleViewModal = (body) => {
    showTemplateModal((prev) => ({
      ...prev,
      isOpen: true,
      body: body,
    }));
  };

  const handleDeleteSMS = (id, type) => {
    swal({
      title: `Are you sure?`,
      text: `Do you really want to delete this ${type}?`,
      icon: "warning",
      buttons: ["Cancel", "Yes, Delete it!"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoader(true);
        const tempToken = JSON.parse(localStorage.getItem("token_gen"))?.access_token;
        const merchantId = localStorage.getItem("Id");

        deleteEmailTemplateSetting(tempToken, merchantId, id).then((res) => {
          setLoader(false);

          if (res.message === "Email template deleted successfully.") {
            swal({
              position: "center",
              icon: "success",
              title: `${type} deleted successfully!`,
              showConfirmButton: false,
              timer: 2000,
            });
            fetchDataBanner();
          } else {
            swal({
              position: "center",
              icon: "error",
              title: res.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        });
      } else {
        swal({
          title: "Cancelled",
          text: `${type} deletion was cancelled.`,
          icon: "info",
          timer: 1500,
          buttons: false,
        });
      }
    });
  };


  useEffect(() => {
    const temp = response;

    if (temp) {
      temp?.map((val) => {
        return (
          (val.Subject = val.Subject),
          (val.fromName = val.fromName),
          (val.fromEmail = val.fromEmail),
          (val.EmailType = val.EmailType),
          (val.body = (

            <Link
              onClick={() => handleViewModal(val.Body)}
            >
              <div>View</div>
            </Link>
          )),
          (val.status = val.status?.toString()),
          (val.delete = (
            <Link onClick={() => handleDeleteSMS(val.id, "Email Template")}>
              <i
                className="fa fa-times-circle"
                style={{ fontSize: "18px" }}
              ></i>
            </Link>
          )),
          (val.edit = (
            <>
              <Link
                className="edit_btn"
                onClick={() => {
                  setIsEdit(true);
                  setCustomHTML(val?.Body)
                  setEmailSetting((prev) => ({
                    ...prev,
                    fromEmail: val?.fromEmail,
                    fromName: val?.fromName,
                    EmailType: getDropdownObject(val?.EmailType, typeDisplay)
                      ? getDropdownObject(val?.EmailType, typeDisplay).value
                      : val?.EmailType,
                    Subject: val?.Subject,
                    Body: val?.Body,
                    status: val?.status === "true" ? true : false,
                    emailPlaceholder: [],
                    templateName: getDropdownObject(val?.EmailType, typeDisplay)
                      ? ""
                      : val?.EmailType,
                    selectedType: getDropdownObject(val?.EmailType, typeDisplay)
                      ? getDropdownObject(val?.EmailType, typeDisplay).value
                      : "",
                  }));
                  window.scrollTo(0, 0);
                }}
                style={{ display: "flex", justifyContent: "center" }}
                csvalue="Edit"
              >
                <i className="fa-solid fa-pen"></i>
                <div className="show_div">Edit</div>
              </Link>
            </>
          ))
        );
      });

      setData(temp);
    }
  }, [response]);
  const fetchDataBanner = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    const id = localStorage.getItem("Id");
    const res = await getEmailTemplateSetting(token?.access_token, id);
    setResponse(res.data?.EmailTemplateSetting);
    setLoader(false);
  };

  useEffect(() => {
    fetchDataBanner();
  }, []);

  useEffect(() => {
    if (selectedType || templateName) {
      setError("");
      return;
    }
  }, [selectedType, templateName]);

  const handleSubmitEmail = async () => {
    const tempToken = JSON.parse(
      localStorage.getItem("token_gen")
    )?.access_token;
    if (!selectedType && !templateName) {
      setError("Either Email Template or Template Name must have a value.");
      return;
    } else {
      const updatedEmailSetting = {
        ...emailSetting,
        EmailType: templateName || selectedType,
      };
      delete updatedEmailSetting.selectedType;
      delete updatedEmailSetting.templateName;
      setLoader(true);
      if (isEdit) {
        updateEmailTemplateSetting(tempToken, updatedEmailSetting).then(
          (res) => {
            setIsEdit(false);
            setLoader(false);
            if (res.message === "Email Template updated successfully") {
              setEmailSetting((prev) => ({
                ...prev,
                fromEmail: "",
                fromName: "",
                EmailType: "",
                Subject: "",
                Body: "",
                status: false,
                templateName: "",
                selectedType: "",
              }));
              setCustomHTML("")
              swal({
                position: "center",
                icon: "success",
                title: "Email Template Setting Update Successfully",
                showConfirmButton: false,
                timer: 2000,
              });
              fetchDataBanner();
            } else {
              swal({
                position: "center",
                icon: "error",
                title: res.message,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          }
        );
      } else {
        customerPortalSetting(tempToken, updatedEmailSetting).then((res) => {
          setLoader(false);
          if (res.message === "Email Template Updated Successfully") {
            setEmailSetting((prev) => ({
              ...prev,
              fromEmail: "",
              fromName: "",
              EmailType: "",
              Subject: "",
              Body: "",
              status: false,
              templateName: "",
              selectedType: "",
            }));
            setCustomHTML("")
            swal({
              position: "center",
              icon: "success",
              title: "Email Template Setting Set Successfully",
              showConfirmButton: false,
              timer: 2000,
            });
            fetchDataBanner();
          } else {
            swal({
              position: "center",
              icon: "error",
              title: res.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        });
      }
    }
  };
  const handleToggle = (e) => {
    setEmailSetting({ ...emailSetting, [e.target.name]: e.target.checked });
  };

  const onChangeEmail = (e) => {
    setEmailSetting({ ...emailSetting, [e.target.name]: e.target.value });
  };

  const handleTypeChange = (e) => {
    setEmailSetting((prev) => ({
      ...prev,
      EmailType: e.value,
      templateName: "",
      selectedType: e.value,
    }));
  };

  const onChangeTemplateName = (e) => {
    const { value } = e.target;
    setEmailSetting((prev) => ({
      ...prev,
      EmailType: value,
      templateName: value,
      selectedType: "",
    }));
  };

  const handleEditorChange = (e, type) => {
    if (type === "editor") {
      const data = e.editor.getData();
      setEmailSetting((prev) => ({
        ...prev,
        Body: data,
      }));
    } else {
      setEmailSetting((prev) => ({
        ...prev,
        Body: e,
      }));
    }
  };

  const handleTabSwitch = (mode) => {
    setActiveMode(mode);
    setShowPreview(false);
  };

  const fetchSchema = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    let schemaName = localStorage.getItem("schemaName");
    schemaName = schemaName.split(" ").join("");
    const response = await getCustomer(token?.access_token, schemaName).then(
      (res) => {
        let newdata = res?.schema?.properties;
        let temp = [];

        for (const property in newdata) {
          temp.push({
            label: property,
            value: property,
            type: newdata[property].type,
            fielddatatype: newdata[property].fielddatatype,
          });
        }
        temp.push({
          label: "valueOfPoints",
          value: "valueOfPoints",
          type: "number",
          fielddatatype: "integer",
        });
        temp.push({
          label: "voucherCode",
          value: "voucherCode",
          type: "string",
          fielddatatype: "text",
        });
        temp.push({
          label: "otp",
          value: "otp",
          type: "string",
          fielddatatype: "text",
        });

        setSelectedPlaceholders(temp);
        setLoader(false);
      }
    );
  };

  useEffect(() => {
    fetchSchema();
  }, []);

  const handleSchemaChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setEmailSetting((prevState) => ({
      ...prevState,
      emailPlaceholder: selectedValues,
    }));
    setSelectedPlaceholders(selectedValues);
  };

  const handleDragStart = (e, placeholder) => {
    e.dataTransfer.setData("text/plain", `{{${placeholder.value}}}`);
    e.dataTransfer.effectAllowed = "copy";
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const placeholder = e.dataTransfer.getData("text/plain");
    if (placeholder && ckEditorRef.current) {
      const editor = ckEditorRef.current.editor;
      editor.insertText(placeholder);
      setEmailSetting((prevState) => ({
        ...prevState,
        emailPlaceholder: placeholder.value,
      }));
    }
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      {/* <Header name={"Email Template"} /> */}
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <>
        {/* <div className="dashboard__content"> */}
        {/* <div className="dashboard__transactionsCard"> */}
        {/* <div className="dashboard__header">
            <div className="dashboard__left">
              <h4 id="transction_list">Email Template</h4>
            </div>
          </div> */}
        <ValidatorForm
          className="dashboard__customerViewMain"
          onSubmit={handleSubmitEmail}
        >
          <div className="dashboard__customerViewCard">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="form-group withIcon">
                  <label>Subject</label>
                  <TextValidator
                    placeholder="Subject"
                    className="form-control"
                    name="Subject"
                    onChange={onChangeEmail}
                    value={Subject}
                    validators={["required"]}
                    errorMessages={["Subject is required"]}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="form-group withIcon">
                  <label>From Name</label>
                  <TextValidator
                    placeholder="Name"
                    type="text"
                    className="form-control"
                    name="fromName"
                    onChange={onChangeEmail}
                    value={fromName}
                    validators={["required"]}
                    errorMessages={["Name is required"]}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="form-group withIcon">
                  <label>Form Email</label>
                  <TextValidator
                    placeholder="novus@loyalty.com"
                    className="form-control"
                    name="fromEmail"
                    onChange={onChangeEmail}
                    value={fromEmail}
                    validators={["required", "isEmail"]}
                    errorMessages={[
                      "From email is required",
                      "Email is not valid",
                    ]}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="form-group withIcon">
                  <label>Email Template</label>
                  <div className="row">
                    <div className="col-11">
                      <SelectValidator
                        placeholder="Select Type"
                        className="custom-ReactSelect bordered"
                        name="selectedType"
                        value={getDropdownObject(selectedType, typeDisplay)}
                        options={typeDisplay}
                        onChange={handleTypeChange}
                      />
                      {error && <div style={{ color: "red" }}>{error}</div>}
                    </div>
                    <div className="col-1 text-center px-0 pt-2">OR</div>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="form-group withIcon">
                  <label>Template Name</label>
                  <TextValidator
                    placeholder="Enter template name"
                    className="form-control"
                    name="templateName"
                    onChange={onChangeTemplateName}
                    value={templateName}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                <div
                  className="person"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <p
                    className="voucher mb-2"
                    style={{
                      display: "flex",
                      width: "25%",
                      marginBottom: "0",
                      color: "black",
                    }}
                  >
                    Status
                  </p>
                  <div className="">
                    <label className="toggle">
                      <input
                        type="checkbox"
                        name="status"
                        checked={status}
                        onChange={handleToggle}
                      />
                      <span className="slider"></span>
                      <span
                        className="labels"
                        data-on="true"
                        data-off="false"
                      ></span>
                    </label>
                  </div>
                </div>
              </div>

              {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                  <div className="form-group">
                    <label>Email PlaceHolder</label>
                    <SelectValidator
                      isMulti
                      placeholder="Select Email PlaceHolder"
                      className="custom-ReactSelect bordered"
                      name="emailPlaceholder"
                      onChange={handleSchemaChange}
                      options={schemaData}
                      getOptionLabel={(option) => (
                        <div 
                          draggable 
                          onDragStart={(e) => handleDragStart(e, option.value)}
                          style={{ cursor: 'move' }}
                        >
                          {option.label}
                        </div>
                      )}
                    />
                  </div>
                </div> */}

              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                <div className="form-group">
                  <label>Drag field for email body:</label>
                  <div className="placeholder-container">
                    {selectedPlaceholders.map((placeholder) => (
                      <div
                        key={placeholder.value}
                        className="draggable-placeholder"
                        draggable
                        onDragStart={(e) => handleDragStart(e, placeholder)}
                      >
                        {`${placeholder.value}`}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div style={{ marginBottom: "1rem" }}>
                    <button
                      type="button"
                      onClick={() => handleTabSwitch("custom")}
                      style={{
                        marginRight: "10px",
                        backgroundColor: activeMode === "custom" ? "#007bff" : "#ccc",
                        color: "white",
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Custom Code
                    </button>

                    <button
                      type="button"
                      onClick={() => handleTabSwitch("editor")}
                      style={{
                        backgroundColor: activeMode === "editor" ? "#007bff" : "#ccc",
                        color: "white",
                        border: "none",
                        padding: "8px 16px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Editor
                    </button>
                  </div>

                  <div className="col-xl-12">
                    {activeMode === "custom" && (
                      <div>
                        {!showPreview ? (
                          <>
                            <textarea
                              value={customHTML}
                              onChange={(e) => {
                                setCustomHTML(e.target.value);
                                handleEditorChange(e.target.value);
                              }}
                              rows={10}
                              style={{
                                width: "100%",
                                padding: "10px",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                                fontFamily: "monospace",
                              }}
                            />
                            <div style={{ marginTop: "10px" }}>
                              <button
                                type="button"
                                onClick={() => setShowPreview(true)}
                                style={{
                                  backgroundColor: "#28a745",
                                  color: "white",
                                  border: "none",
                                  padding: "8px 16px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                Preview
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              style={{
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                padding: "10px",
                                background: "#fff",
                              }}
                              dangerouslySetInnerHTML={{ __html: customHTML }}
                            />
                            <div style={{ marginTop: "10px" }}>
                              <button
                                type="button"
                                onClick={() => setShowPreview(false)}
                                style={{
                                  backgroundColor: "#6c757d",
                                  color: "white",
                                  border: "none",
                                  padding: "8px 16px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                Back to Edit
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {activeMode === "editor" && (
                      <div>
                        <CKEditor
                          ref={ckEditorRef}
                          config={{ versionCheck: false }}
                          data={Body}
                          onChange={(e) => handleEditorChange(e, "editor")}
                          name="Body"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 py-3">
                <div
                  className="button-section"
                  style={{ justifyContent: "flex-end", display: "flex" }}
                >
                  <button type="submit" className="btn btn-primary">
                    {isEdit ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ValidatorForm>

        <div className="dashboard__customersCard">
          {/* <div className="dashboard__header">
            <div className="dashboard__left">
              <h4 id="transction_list">Email Template List</h4>
            </div>
          </div> */}
          <div className="dashboard__body">
            <Paginated columns={EMAIL_TEMPLATE_COLUMN} data={data || []} />
          </div>
        </div>

        {templateModal?.isOpen && (
          <EmailTemplateModal
            show={templateModal?.isOpen}
            close={() =>
              showTemplateModal((prev) => ({ ...prev, isOpen: false }))
            }
            body={templateModal.body}
            header={"Email Template"}
          />
        )}
        {/* </div> */}
        {/* </div> */}
      </>
    </div>
  );
}

export default EmailTemplate;
